export const HubSpotVariants = {
  Base: 'Base',
  Featured: 'Featured',
} as const;

export type HubSpotVariant = (typeof HubSpotVariants)[keyof typeof HubSpotVariants];
